<template>
  <el-popover
    placement="bottom"
    style="width: 100%; display: inline-block"
    trigger="click"
    popper-class="curstom-tree"
  >
    <div class="custom_select" slot="reference">
      <div class="custom_select__tags" style="width: 100%">
        <span>
          <span
            v-for="(item, index) of checkAreaArr.slice(0, 2)"
            :key="index"
            class="custom_tag custom_tag--info custom_tag--small custom_tag--light"
          >
            <span class="custom-select__tags-text">{{ item.areaName }}</span>
            <i
              v-if="isClose"
              class="el-icon-error custom-icon-close custom-tag__close"
              @click.stop="cancelNode(item.id)"
            ></i>
          </span>

          <span
            v-show="checkAreaArr && checkAreaArr.length > 2"
            class="custom_tag custom_tag--info custom_tag--small custom_tag--light"
          >
            <span class="custom-select__tags-text">
              +{{ checkAreaArr.length }}
            </span>
          </span>
        </span>
      </div>
      <el-input
        v-if="isNeedInput"
        size="small"
        :class="[!isClose ? inputClass : '']"
        slot="reference"
        :placeholder="checkAreaArr.length ? '' : '请选择'"
        readonly
      ></el-input>
    </div>

    <el-tree
      :data="treeData"
      ref="tree"
      @check="treeCheckChange"
      @node-expand="nodeExpand"
      show-checkbox
      node-key="id"
      :default-checked-keys="defCheckKeys"
      :props="defaultProps"
    ></el-tree>
  </el-popover>
</template>

<script>
export default {
  props: {
    // 默认选中的城市id
    defCheckKeys: {
      type: Array,
      default: () => {
        return [];
      }
    },
    index: {
      type: Number,
      default: 0
    },
    // 是否可以从input框中删除地区
    isClose: {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    inputClass: {
      type: String,
      default: () => {
        return "clear_default_class";
      }
    },
    isNeedInput: {
      type: Boolean,
      default: () => {
        return true;
      }
    }
  },
  data() {
    return {
      treeData: [],
      defaultProps: {
        id: "id",
        label: "areaName",
        children: "children",
        isLeaf: "leaf"
      },
      checkAreaArr: [] // 选中的节点 过滤之后的
    };
  },
  watch: {
    defCheckKeys(val) {
      if (val.length) {
         this.$refs.tree?.setCheckedNodes([]);
         this.setChecked(val.map((item) => item[this.defaultProps.id]));
         this.initCheckKeyArr();
       } else {
         // 清空选中项
        this.checkAreaArr = [];
        this.$refs.tree.setCheckedKeys([]);
       }
    }
  },
  computed: {},
  methods: {
    // 获取全国城市
    async getAreaCity(id) {
      const { code, data, message } = await this.$request({
        url: "Common -> listTreeByParentId",
        data: {}
      });
      this.treeData = data || [];
      // 之前有选中的数据 用来回显
      if (this.defCheckKeys?.length) {
        this.$nextTick(() => {
          this.setChecked(this.defCheckKeys); // 设置节点选中
          const copydefCheckKeys = this.defCheckKeys.concat();
          this.treeCheckChange(); // 在input中回显
          // 在这里进行过滤，将不符合条件的孩子给过滤掉
          // 如果只是查看 不可操作
          if (!this.isClose && this.treeData.length > 0) {
            const data = this.disabledData(this.treeData); // 设置数据disable
            this.$set(this, "treeData", data);
          }
        });
      }

      // 自动展开根节点  (当不自动触发时, 禁用有问题)
      this.$nextTick(() => {
        const node = this.$refs.tree?.getNode("1");
        if (this.treeData?.length > 0) {
          this.nodeExpand(this.treeData[0], node);
        }
      });
    },

    disabledData(data) {
      data.forEach((item) => {
        item["disabled"] = true;
        if (item.children) {
          this.disabledData(item.children);
        }
      });
      return data;
    },
    // 打开节点
    nodeExpand(item, node) {
      if (node) {
        node.expanded = true;
      }
    },
    initCheckKeyArr() {
      const checkNodeArr = this.$refs.tree?.getCheckedNodes(); // 当前选中的节点数组
      const checkKeyArr = this.$refs.tree.getCheckedKeys(); // 当前选中的节点id数组
      let checkLeafNode = checkNodeArr.filter((item) => !item.children);
      let checkAreaArr = [];
      for (let i = 0; i < checkNodeArr.length; i++) {
        if (!checkKeyArr.includes(checkNodeArr[i].pid)) {
          // 当前节点的父节点 没选中
          checkAreaArr.push({
            areaName: checkNodeArr[i].areaName,
            id: checkNodeArr[i].id,
            pid: checkNodeArr[i].pid
          });
        }
      }
      if (checkKeyArr.includes("1")) {
        checkAreaArr = [
          {
            areaName: "全国",
            id: "1",
            pid: "0"
          }
        ];
        checkLeafNode = checkAreaArr;
      }
      this.checkAreaArr = checkAreaArr;
      return {
        checkLeafNode,
        checkAreaArr
      };
    },
    // 节点选择变化时触发
    treeCheckChange() {
      const {checkLeafNode, checkAreaArr} = this.initCheckKeyArr();
      this.$emit("checkNodeChange", checkLeafNode, checkAreaArr, this.index);
    },

    // 设置节点为选中
    setChecked(data) {
      data.forEach((item) => {
        if (this.$refs.tree) {
          this.$refs.tree.setChecked(item, true, true);
        }
      });
    },

    // 删除选中的节点
    cancelNode(id) {
      this.$refs.tree.setChecked(id, false, true);
      this.treeCheckChange();
    }
  },
  mounted() {
    this.getAreaCity();
  }
};
</script>
<style scoped lang="scss"></style>
<style lang="less" scoped>
// /deep/.el-input--small .el-input__inner{
//       height: 40px;
//     line-height: 40px;
// }
.w400 {
  width: 400px;
}

/deep/ .el-popper {
  /* max-height: 300px;注释掉，不然会出现滚动条的 */
  overflow-y: auto;
  /* min-height: 150px; */
  height: 600px;
}
/deep/ .el-popover__reference-wrapper,
/deep/ .el-popover__reference {
  width: 100%;
  display: inline-block;
}
.custom_select {
  position: relative;
  display: inline-block;
  .custom_select__tags {
    position: absolute;
    line-height: normal;
    white-space: normal;
    z-index: 1;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    // left: -10px;
    span {
      display: contents;
      .custom_tag--info {
        background-color: #f4f4f5;
        border-color: #e9e9eb;
        color: #909399;
        .custom-select__tags-text {
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .custom-tag__close {
          color: #909399;
        }
        .custom-icon-close {
          // background-color: #c0c4cc;
          top: 0;
          flex-shrink: 0;
          transform: scale(0.8);
          border-radius: 50%;
          text-align: center;
          position: relative;
          cursor: pointer;
          font-size: 12px;
          height: 16px;
          width: 16px;
          line-height: 16px;
          vertical-align: middle;
          top: -1px;
          right: -5px;
          cursor: pointer;
        }
        .custom-icon-close::before {
          display: block;
          transform: translateY(0.5px);
          transform: scale(1.5);
        }
      }
      .custom_tag {
        box-sizing: border-box;
        border-color: transparent;
        margin: 2px 0 2px 5px;
        background-color: #f0f2f5;
        display: flex;
        max-width: 100%;
        align-items: center;
      }
      .custom_tag--small {
        height: 24px;
        padding: 0 8px;
        line-height: 22px;
        border-radius: 5px;
      }
      // .curstom-tree{
      //   top: 200px !important;
      // }
    }
  }
}

// 查看课程详情时 展示
.clear_default_class {
  /deep/ .el-input__inner {
    border: none;
    background: #f7f7f7;
  }
}

// 机构审核时 展示
.org_default_class {
  /deep/ .el-input__inner {
    border-color: #e4e7ed;
    background: #f5f7fa;
  }
}
</style>
<style>
.curstom-tree {
  /* max-height: 300px;注释掉，不然会出现滚动条的 */
  overflow-y: auto !important;
  /* min-height: 150px; */
  height: 500px !important;
}
</style>
